import { dataYingxiaotongSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconYingxiaotongSolid = /*#__PURE__*/createIcon(dataYingxiaotongSolid)
export default IconYingxiaotongSolid
